<template>
  <div class="navbar-container d-flex content align-items-center">
    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <!-- <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li> -->
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-flex">
      <dark-Toggler class="d-block" />
    </div>
    <!-- <div>
      <feather-icon
        icon="DollarSignIcon"
        size="21"
      />
      {{ userInfo.money | formatCurrency }}
    </div> -->
    <b-navbar-nav class="nav align-items-center ml-auto">
      <b-nav-item-dropdown
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >
        <template #button-content>
          <div class="d-sm-flex d-none user-nav">
            <p class="user-name font-weight-bolder mb-0">
              {{ userInfo.username }}
            </p>
            <!-- <span class="user-status">Admin</span> -->
          </div>
          <b-avatar
            size="40"
            variant="light-primary"
            badge
            :src="require('@/assets/images/avatars/13-small.png')"
            class="badge-minimal"
            badge-variant="success"
          />
        </template>

        <!-- <b-dropdown-item link-class="d-flex align-items-center">
          <feather-icon
            size="16"
            icon="UserIcon"
            class="mr-50"
          />
          <span>Profile</span>
        </b-dropdown-item>

        <b-dropdown-item link-class="d-flex align-items-center">
          <feather-icon
            size="16"
            icon="MailIcon"
            class="mr-50"
          />
          <span>Inbox</span>
        </b-dropdown-item>

        <b-dropdown-item link-class="d-flex align-items-center">
          <feather-icon
            size="16"
            icon="CheckSquareIcon"
            class="mr-50"
          />
          <span>Task</span>
        </b-dropdown-item>

        <b-dropdown-item link-class="d-flex align-items-center">
          <feather-icon
            size="16"
            icon="MessageSquareIcon"
            class="mr-50"
          />
          <span>Chat</span>
        </b-dropdown-item>

        <b-dropdown-divider /> -->

        <b-dropdown-item
          link-class="d-flex align-items-center"
          @click="openSettings"
        >
          <feather-icon size="16" icon="SettingsIcon" class="mr-50" />
          <span>Cài đặt</span>
        </b-dropdown-item>

        <b-dropdown-item link-class="d-flex align-items-center" @click="logout">
          <feather-icon size="16" icon="LogOutIcon" class="mr-50" />
          <span>Đăng xuất</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>

    <b-modal v-model="isShowSettings" title="Cài đặt Chat" centered size="lg">
      <div class="d-flex flex-wrap" style="gap: 20px">
        <div v-for="(d, index) in daysOnWeek" :key="index">
          <div>{{ d }}</div>
          <div>
            <vue-timepicker v-model="timeSchedule[index].from"></vue-timepicker>
          </div>
          -----
          <div>
            <vue-timepicker v-model="timeSchedule[index].to"></vue-timepicker>
          </div>
        </div>
      </div>

      <b-form-textarea
        class="mt-2"
        v-model="message2"
        placeholder="Nhập tin nhắn. Tin nhắn tự động trong khoảng thời gian được cài đặt ở trên"
        rows="3"
        max-rows="6"
      ></b-form-textarea>

      <b-form-textarea
        class="mt-2"
        v-model="message"
        placeholder="Nhập tin nhắn. Tin nhắn tự động khi KHÔNG trong khoảng thời gian được cài đặt."
        rows="3"
        max-rows="6"
      ></b-form-textarea>
      <template #modal-footer>
        <loading-button variant="primary" @click="submitSettings"
          >Lưu</loading-button
        >
      </template>
    </b-modal>
  </div>
</template>

<script>
import {
  BLink,
  BNavbarNav,
  BNavItemDropdown,
  BDropdownItem,
  BDropdownDivider,
  BAvatar,
  BModal,
  BTime,
  BFormTextarea,
} from "bootstrap-vue";
import DarkToggler from "@core/layouts/components/app-navbar/components/DarkToggler.vue";
import { mapState } from "vuex";
import { formatCurrency } from "@/@core/utils/filter";
import useJwt from "@/auth/jwt/useJwt";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import LoadingButton from "@/@core/components/loading-button/LoadingButton.vue";
import API from "@/api";

export default {
  components: {
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    // BDropdownDivider,
    BAvatar,

    // Navbar Components
    DarkToggler,
    BModal,
    BTime,
    VueTimepicker,
    LoadingButton,
    BFormTextarea,
  },

  data() {
    return {
      isShowSettings: false,
      daysOnWeek: [
        "Thứ 2",
        "Thứ 3",
        "Thứ 4",
        "Thứ 5",
        "Thứ 6",
        "Thứ 7",
        "Chủ nhật",
      ],
      timeSchedule: [
        { from: "00:00", to: "23:59" },
        { from: "00:00", to: "23:59" },
        { from: "00:00", to: "23:59" },
        { from: "00:00", to: "23:59" },
        { from: "00:00", to: "23:59" },
        { from: "00:00", to: "23:59" },
        { from: "00:00", to: "23:59" },
      ],
      message: "",
      message2: ""
    };
  },

  filters: {
    formatCurrency,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.info,
    }),
  },

  created() {
    // this.$store.dispatch('user/getUserInfo')
  },

  methods: {
    logout() {
      localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName);
      this.$router.push({ name: "login" });
      if (this.$socket.connected) {
        this.$socket.close();
      }
    },

    openSettings() {
      this.$http
        .get(API.CHAT_SETTINGS)
        .then(res => {
          if(res.success) {
            this.timeSchedule = res.data.schedule.map(e => {
              const { from, to } = e;
              return { from, to }
            });
            this.message = res.data.message
            this.message2 = res.data.message2
          }
        })
        .catch((err) => {
          return this.$toast.error(err?.response?.data?.error?.message);
        });
      this.isShowSettings = true;
    },

    submitSettings() {
      this.$http
        .put(API.CHAT_SETTINGS, {
          schedule: this.timeSchedule,
          message: this.message,
          message2: this.message2
        }).then(res => {
          this.isShowSettings = false;
          return this.$toast.success("Cập nhật thành công.");
        })
        .catch((err) => {
          return this.$toast.error(err?.response?.data?.error?.message);
        });
    },
  },
};
</script>
